module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_26-803e1e29e6a991fb16c4d87ec8c56fa8.jpg";